import React from 'react'
import { string } from 'prop-types'
import styled from '@emotion/styled'
import { COLORS, FONT_SIZES, MQ } from 'utils/styleHelpers'

const RfqHeaderWrap = styled.div`
	color: ${COLORS.WHITE};
	font-weight: 300;
	font-size: ${FONT_SIZES.H6};
	line-height: ${FONT_SIZES.H6};
	padding: 0 5px;
	position: absolute;
	top: -60px;
	text-align: center;
	width: 100%;

	${MQ.XS} {
		font-size: ${FONT_SIZES.H5};
		line-height: ${FONT_SIZES.H5};
		top: -65px;
	}

	${MQ.S} {
		font-size: 17px;
		line-height: 17px;
		top: -80px;
	}

	${MQ.M} {
		font-size: 22px;
		line-height: 22px;
	}
`

const RfqHeaderText = styled.div`
	padding-top: 3px;
	color: ${({ fontColor }) => fontColor};
`

const defaultProps = {
	fontColor: '#fff',
}

const propTypes = {
	category: string.isRequired,
	fontColor: string,
}

const RfqHeader = ({ category, fontColor }) => (
	<RfqHeaderWrap>
		<RfqHeaderText fontColor={fontColor}>
			Take <strong>3 minutes</strong> to define your needs.
		</RfqHeaderText>
		<RfqHeaderText>Get competing quotes from top {category} providers.</RfqHeaderText>
		<RfqHeaderText fontColor={fontColor}>
			<strong>Be amazed.</strong>
		</RfqHeaderText>
	</RfqHeaderWrap>
)

RfqHeader.defaultProps = defaultProps
RfqHeader.propTypes = propTypes

export default RfqHeader
